// Routes de la lecture assistée des documents (lot L7), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageAssistance } from './PageAssistance';
import { PageLecture } from './PageLecture';

export const routesAssistance: RouteObject[] = [
  { path: '/assistance-documentaire', element: <PageAssistance /> },
  { path: '/assistance-documentaire/lectures/:id', element: <PageLecture /> },
];
